import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Box,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  Alert,
  Select
} from '@mui/material';
import moment from 'moment-timezone';
import { useEffect, useState } from "react";
import { api } from "../../../services/api";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { useMediaQuery } from "react-responsive";
import useGetFechasEvento from '../../../hooks/useGetFechasEvento';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateEditTarifa from '../../../components/modales/tarifas/CreateTarifa';
import { AddOutlined, Edit } from '@mui/icons-material';
import BannerPreview from '../../../components/evento/BannerPreview';

export const SegundoPaso = ({ eventId: propEventId, isPublic }) => {
  const location = useLocation();
  const { eventId: stateEventId } = location.state || {};
  const eventId = stateEventId || propEventId;
  const [tipoSeleccionado, setTipoSeleccionado] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [tarifas, setTarifas] = useState([]);
  const [tarifasTipo, setTarifasTipo] = useState([]);
  const [errorDate, setErrorDate] = useState(false);
  const { fechasEvento } = useGetFechasEvento(eventId);
  const [tarifaActual, setTarifaActual] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [tarifaToDelete, setTarifaToDelete] = useState(null);

  const initForm = {
    idevento: eventId,
    idmoneda: 1,
    concepto: '',
    precio: 0,
    idtipo: '',
    idubicacion: '',
    nueva_ubicacion: true,
    nombre_ubicacion: '',
    limite_persona: 10,
    limite_maximo: 100,
    asumir_comision: false,
    inicio_venta_fecha: "",
    inicio_venta_hora: "",
    fin_venta_fecha: "",
    fin_venta_hora: "",
    privado: false,
    fechas: [],
    informacion_adicional: false
  };

  const [formData, setFormData] = useState(initForm);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [checked, setChecked] = useState(false);
  const [preguntas, setPreguntas] = useState([{
    informacion_adicional: "",
    id_tarifa: 0,
    id_evento: eventId,
  }]);
  const [loadingTarifas, setLoadingTarifas] = useState(false);


  // cargo los tipos de tarifas y ubicaciones
  useEffect(() => {
    const cargarUbicaciones = async () => {
      try {
        const response = await api.locations.getAll(eventId);
        if (response.status === "success") {
          setUbicaciones(response.data.ubicaciones || []);
        }
      } catch (error) {
        console.error("Error al cargar ubicaciones:", error);
      }
    };

    const callTipoTarifas = async () => {
      try {
        const response = await api.tarifas.GetAllTarifasTipos();
        if (response.status === "success") {
          setTarifasTipo(response.data.tarifasTipo);
        }
      } catch (error) {
        console.error("Error al cargar tipos de tarifas:", error);
      }
    };

    cargarUbicaciones();
    callTipoTarifas();
  }, [eventId]);

  const handleOpenModal = () => {
    setFormData({
      ...initForm,
      idtipo: tipoSeleccionado === 'tickets' ? 1 : 2
    });
    setFormErrors({});
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setFormErrors({});
    setTarifaActual(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "limite_persona" || name === "precio" || name === "limite_maximo") {
      if (/^\d*\.?\d*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    }
    else if (name === "fechas") {
      setFormData({
        ...formData,
        [name]: [...new Set(value)],
      });
    }
    else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (name !== "fechas" && typeof value === "string" && value.trim() !== "") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: false,
      }));
    }
  };

  const handleChangeVisivilidad = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value === "true",
    });
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      asumir_comision: checked
    }));
  };

  const handleCheckboxChange2 = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    setFormData((prevData) => ({
      ...prevData,
      informacion_adicional: isChecked,
    }));

    if (isChecked && preguntas.length === 0) {
      setPreguntas([{ id_tarifa: 0, id_evento: eventId, informacion_adicional: "" }]);
    } else if (!isChecked) {
      setPreguntas(preguntas.map(pregunta => ({
        ...pregunta,
        informacion_adicional: "",
      })));
    }
  };

  const agregarPregunta = () => {
    setPreguntas([
      ...preguntas,
      { id_tarifa: 0, id_evento: eventId, informacion_adicional: "" }
    ]);
  };

  const handlePreguntaChange = (index, value) => {
    if (preguntas.length === 0) return;

    const nuevasPreguntas = [...preguntas];
    if (index >= 0 && index < nuevasPreguntas.length) {
      nuevasPreguntas[index].informacion_adicional = value;
      setPreguntas(nuevasPreguntas);
    }
  };

  const eliminarPregunta = (index) => {
    if (preguntas.length > 1) {
      setPreguntas(preguntas.filter((_, i) => i !== index));
    }
  };

  const handleGuardarPreguntas = async (tarifaId) => {
    const preguntasFiltradas = preguntas.filter(pregunta => pregunta.informacion_adicional.trim() !== "");

    if (preguntasFiltradas.length === 0) return;

    const dataToSend = preguntasFiltradas.map(pregunta => ({
      id_tarifa: tarifaId,
      id_evento: eventId,
      informacion_adicional: pregunta.informacion_adicional
    }));

    try {
      const response = await api.infoAdicional.createPreguntas(eventId, dataToSend);

      if (response.status !== "success") {
        throw new Error(response.message);
      }

      setChecked(false);
      setPreguntas([]);

      toast.success("Preguntas guardadas correctamente.", {
        position: "top-right",
        autoClose: 2000,
      });

    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.privado) {
      if (!formData.inicio_venta_fecha || !formData.inicio_venta_hora || !formData.fin_venta_fecha || !formData.fin_venta_hora) {
        setErrorDate(true);
        toast.error("Las fechas de inicio y fin de venta son obligatorias para tarifas públicas.", {
          position: "top-right",
          autoClose: 4000,
        });
        return;
      }
    }

    let inicioVenta = null;
    let finVenta = null;
    if (!formData.privado) {
      try {
        inicioVenta = new Date(`${formData.inicio_venta_fecha}T${formData.inicio_venta_hora}`);
        finVenta = new Date(`${formData.fin_venta_fecha}T${formData.fin_venta_hora}`);

        if (inicioVenta >= finVenta) {
          toast.error("La fecha de inicio de venta debe ser anterior a la fecha de fin de venta.", {
            position: "top-right",
            autoClose: 4000,
          });
          return;
        }
      } catch (error) {
        toast.error("Formato de fecha inválido. Por favor, verifica las fechas.", {
          position: "top-right",
          autoClose: 4000,
        });
        return;
      }
    }

    const errors = {
      concepto: formData.concepto === '',
      ...(tipoSeleccionado === 'tickets' && {
        nombre_ubicacion: formData.nueva_ubicacion && formData.nombre_ubicacion === '',
        idubicacion: !formData.nueva_ubicacion && !formData.idubicacion,
        limite_persona: formData.nueva_ubicacion && formData.limite_persona === '',
        limite_maximo: formData.nueva_ubicacion && formData.limite_maximo === '',
      }),
      ...(tipoSeleccionado === 'consumicion' && {
        limite_persona: formData.limite_persona === '',
        limite_maximo: formData.limite_maximo === '',
      }),
      fechas: formData.fechas?.length === 0,
    };
    setFormErrors(errors);

    const isValid = Object.values(errors).every(error => !error);

    if (isValid) {
      try {
        let idUbicacion = formData.idubicacion;

        // si la ubi es nueva, la creamos primero
        if (tipoSeleccionado === 'tickets' && formData.nueva_ubicacion) {
          // si existe alguna ubi con el mismo nombre en el mismo evento, se reusa el id
          const ubicacionExistente = ubicaciones.find(
            u => u.ubicacion.toLowerCase() === formData.nombre_ubicacion.toLowerCase()
          );

          if (ubicacionExistente) {
            idUbicacion = ubicacionExistente.id;
          } else {
            const nuevaUbicacion = {
              idevento: parseInt(eventId),
              ubicacion: formData.nombre_ubicacion,
              limitepersona: parseInt(formData.limite_persona),
              limitemaximo: parseInt(formData.limite_maximo),
            };

            try {
              const respUbicacion = await api.locations.createLocation(nuevaUbicacion);

              if (respUbicacion.status !== "success") {
                throw new Error(respUbicacion.message || "Error al crear la ubicación");
              }

              idUbicacion = respUbicacion.data.ubicacion.id;

              setUbicaciones(prevUbicaciones => [...prevUbicaciones, respUbicacion.data.ubicacion]);
            } catch (error) {
              console.error("Error al crear ubicación:", error);
              throw new Error(`Error al crear la ubicación: ${error.message}`);
            }
          }
        }

        const tarifaData = {
          ...formData,
          idevento: parseInt(eventId),
          precio: parseFloat(formData.precio),
          idtipo: parseInt(formData.idtipo),
          idubicacion: tipoSeleccionado === 'tickets' ? parseInt(idUbicacion || 0) : 0,
          limite_persona: parseInt(formData.limite_persona || 0),
          limite_maximo: parseInt(formData.limite_maximo || 0),
          fechas: formData.fechas?.map(fechaId => ({ id: fechaId })),
          ...(inicioVenta && { inicio_venta: inicioVenta.toISOString() }),
          ...(finVenta && { fin_venta: finVenta.toISOString() }),
          informacion_adicional: formData.informacion_adicional,
        };

        let response;
        if (tarifaActual) {
          response = await api.tarifas.updateTarifa(tarifaActual.id, tarifaData);
        } else {
          response = await api.tarifas.createTarifa(tarifaData);
        }

        if (response.status === "success") {
          const tarifaId = response.data?.tarifa.id || tarifaActual?.id;

          if (tarifaId && formData.informacion_adicional && preguntas.length > 0 &&
            !preguntas.some(pregunta => pregunta.informacion_adicional?.trim() === "")) {
            await handleGuardarPreguntas(tarifaId);
          }

          if (tarifaActual) {
            setTarifas(prevTarifas =>
              prevTarifas.map(t => t.id === tarifaActual.id ? response.data.tarifa : t)
            );
          } else {
            setTarifas(prevTarifas => [...prevTarifas, response.data.tarifa]);
          }

          setModalOpen(false);
          setFormData(initForm);
          setTarifaActual(null);
          setPreguntas([{
            informacion_adicional: "",
            id_tarifa: 0,
            id_evento: eventId,
          }]);

          toast.success(tarifaActual ? "Tarifa actualizada correctamente." : "Tarifa creada correctamente.", {
            position: "top-right",
            autoClose: 2000,
          });
        } else {
          throw new Error(response.message || "Error al procesar la tarifa");
        }
      } catch (error) {
        toast.error(error.message, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } else {
      toast.error("Por favor, completa todos los campos obligatorios.", {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const handleEditarTarifa = (tarifa) => {
    const tipo = tarifa.idtipo === 1 ? 'tickets' : 'consumicion';
    setTipoSeleccionado(tipo);

    const fechaInicio = tarifa.inicio_venta ? moment(tarifa.inicio_venta).format('YYYY-MM-DD') : '';
    const horaInicio = tarifa.inicio_venta ? moment(tarifa.inicio_venta).format('HH:mm') : '';
    const fechaFin = tarifa.fin_venta ? moment(tarifa.fin_venta).format('YYYY-MM-DD') : '';
    const horaFin = tarifa.fin_venta ? moment(tarifa.fin_venta).format('HH:mm') : '';

    const fechasIds = tarifa.fechas?.map(fecha => fecha.id) || [];

    let ubicacionInfo = null;
    if (tipo === 'tickets' && tarifa.idubicacion) {
      ubicacionInfo = ubicaciones.find(u => u.id === tarifa.idubicacion);
      console.log("Ubicación encontrada:", ubicacionInfo);
    }

    setFormData({
      idevento: eventId,
      idmoneda: tarifa.idmoneda || 1,
      concepto: tarifa.concepto || '',
      precio: tarifa.precio || 0,
      idtipo: tarifa.idtipo || '',
      idubicacion: tarifa.idubicacion || '',
      nueva_ubicacion: false,
      nombre_ubicacion: ubicacionInfo?.ubicacion || '',
      limite_persona: tipo === 'tickets' ?
        (ubicacionInfo?.limitepersona || tarifa.limite_persona || 10) :
        (tarifa.limite_persona || 10),
      limite_maximo: tipo === 'tickets' ?
        (ubicacionInfo?.limitemaximo || tarifa.limite_maximo || 100) :
        (tarifa.limite_maximo || 100),
      asumir_comision: tarifa.asumir_comision || false,
      inicio_venta_fecha: fechaInicio,
      inicio_venta_hora: horaInicio,
      fin_venta_fecha: fechaFin,
      fin_venta_hora: horaFin,
      privado: tarifa.privado || false,
      fechas: fechasIds,
      informacion_adicional: tarifa.informacion_adicional || false
    });

    setTarifaActual(tarifa);

    setModalOpen(true);
  };

  const handleOpenDeleteConfirm = (tarifaId) => {
    setTarifaToDelete(tarifaId);
    setConfirmDialogOpen(true);
  };
  const handleConfirmDelete = async () => {
    try {
      const response = await api.tarifas.deleteTarifa(tarifaToDelete);

      if (response.status === "success") {
        toast.success("Tarifa eliminada correctamente.", {
          position: "top-right",
          autoClose: 2000,
        });

      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Error al eliminar la tarifa", {
        position: "top-right",
        autoClose: 4000,
      });
    } finally {
      setConfirmDialogOpen(false);
      setTarifaToDelete(null);
    }
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
    @keyframes pulse {
      0% { opacity: 0.6; }
      50% { opacity: 0.3; }
      100% { opacity: 0.6; }
    }
  `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);

  return (
    <Container maxWidth="lg" sx={{ backgroundColor: "" }}>
      <Box sx={{ mt: 5, mb: 2, }}>
        <Typography variant="h7" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062", textAlign: "start" }}>
          Configurá las tarifas de tu evento según el tipo de acceso o consumición que quieras brindar.
        </Typography>
      </Box>
      {/* seccion selector de tarifa y crear */}
      <Box sx={{ p: 4, mb: 4, display: 'flex', justifyContent: 'center', width: "100%", flexWrap:"wrap", border: "1px solid #4b4d63", borderRadius: "10px", backgroundColor: "#F9FAFB" }}>
        <FormControl
          sx={{
            minWidth: 200,
            mr: 2,
            '& .MuiOutlinedInput-root': {
              fontFamily: "Bricolage Grotesque",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
              height: "40px",
            },
            '& .MuiInputLabel-root': {
              fontFamily: "Bricolage Grotesque",
              '&.Mui-focused': {
                color: '#5656FF',
              },
              transform: 'translate(14px, 10px) scale(1)',
              '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -9px) scale(0.75)',
              }
            },
            '& .MuiFormHelperText-root': {
              fontFamily: "Bricolage Grotesque",
            }
          }}
        >
          <InputLabel id="tipo-label">Tipo de tarifa</InputLabel>
          <Select
            sx={{
              backgroundColor: "#ffff",
              '& .MuiSelect-select': {
                padding: "8px 14px",
                display: 'flex',
                alignItems: 'center',
                height: "24px",
              }
            }}
            labelId="tipo-label"
            id="tipo-selector"
            value={tipoSeleccionado}
            label="Tipo de tarifa"
            onChange={(e) => setTipoSeleccionado(e.target.value)}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              PaperProps: {
                style: {
                  fontFamily: "Bricolage Grotesque",
                },
              },
            }}
          >
            <MenuItem value="">
              <em>Seleccionar...</em>
            </MenuItem>
            <MenuItem value="tickets">Tickets - Gestioná el acceso a tu evento con tickets a medida.</MenuItem>
            <MenuItem value="consumicion">Consumiciones - Ofrecé lo que quieras: comidas, bebidas y más.</MenuItem>
          </Select>
          <FormHelperText>Selecciona el tipo de tarifa que deseas crear</FormHelperText>
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          startIcon={<AddOutlined />}
          disabled={!tipoSeleccionado}
          onClick={handleOpenModal}
          sx={{
            bgcolor: '#5656ff',
            fontFamily: "Bricolage Grotesque",
            padding: "4px 16px",
            '&:hover': { bgcolor: '#4545ee' },
            '&.Mui-disabled': {
              bgcolor: '#e0e0e0',
              color: '#ababab'
            }
          }}
        >
          Crear {tipoSeleccionado === 'tickets' ? 'Ticket' : tipoSeleccionado === 'consumicion' ? 'Consumición' : ''}
        </Button>
      </Box>

      {/* tabla*/}
      <TableContainer component={Paper} className="mt-3" sx={{
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
        border: '1px solid #E6E6FF',
      }}>
        <Table aria-label="tabla de tarifas">
          <TableHead sx={{ backgroundColor: "#E6E6FF" }}>
            <TableRow>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>ID</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Nombre</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Tipo</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Precio</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Inicio de Venta</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>Fin de Venta</TableCell>
              <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingTarifas ? (
              Array(4).fill(0).map((_, index) => (
                <TableRow key={`skeleton-tarifa-${index}`}>
                  {[...Array(7)].map((_, cellIdx) => (
                    <TableCell key={cellIdx}>
                      <div style={{
                        backgroundColor: '#f0f0f5',
                        height: '24px',
                        width: cellIdx === 1 ? '70%' : '90%',
                        borderRadius: '4px',
                        animation: 'pulse 1.5s infinite ease-in-out'
                      }}></div>
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) :
              tarifas.length > 0 ? (
                tarifas.map((tarifa) => (
                  <TableRow key={tarifa.id} hover sx={{
                    '&:hover': { backgroundColor: '#F5F7FF' }
                  }}>
                    <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>{tarifa.id}</TableCell>
                    <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>{tarifa.concepto}</TableCell>
                    <TableCell sx={{ fontFamily: "Bricolage Grotesque" }}>
                      {tarifa.idtipo === 1 ? 'Ticket' : 'Consumición'}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "Bricolage Grotesque" }}>${tarifa.precio.toFixed(2)}</TableCell>
                    <TableCell sx={{ fontFamily: "Bricolage Grotesque" }}>
                      {tarifa.inicio_venta
                        ? moment(tarifa.inicio_venta).format('DD/MM/YYYY HH:mm')
                        : 'No especificado'}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "Bricolage Grotesque" }}>
                      {tarifa.fin_venta
                        ? moment(tarifa.fin_venta).format('DD/MM/YYYY HH:mm')
                        : 'No especificado'}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton
                        color="primary"
                        onClick={() => handleEditarTarifa(tarifa)}
                        title="Editar"
                        sx={{ color: "#5656ff" }}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleOpenDeleteConfirm(tarifa.id)}
                        title="Eliminar"
                        sx={{ color: "#FF5656" }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Alert severity="info" sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      fontFamily: "Bricolage Grotesque"
                    }}>
                      No hay tarifas creadas para este evento
                    </Alert>
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
      >
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de que deseas eliminar esta tarifa?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)}>Cancelar</Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ mt: 4, textAlign: 'center', fontStyle: 'italic', color: 'text.secondary' }}>
        <Typography variant="body2">
          Si tu evento es público, las tarifas estarán disponibles una vez vincules tu cartera.
        </Typography>
      </Box>
      {isPublic && eventId && <BannerPreview eventId={eventId} />}
      {/* modal para crear o editar la tarifa */}
      <CreateEditTarifa
        modalOpen={modalOpen}
        handleCloseModal={handleCloseModal}
        tipoSeleccionado={tipoSeleccionado}
        tarifaActual={tarifaActual}
        formData={formData}
        setFormData={setFormData}
        formErrors={formErrors}
        fechasEvento={fechasEvento}
        ubicaciones={ubicaciones}
        preguntas={preguntas}
        setPreguntas={setPreguntas}
        checked={checked}
        handleChange={handleChange}
        handleChangeVisivilidad={handleChangeVisivilidad}
        handleCheckboxChange={handleCheckboxChange}
        handleCheckboxChange2={handleCheckboxChange2}
        handlePreguntaChange={handlePreguntaChange}
        agregarPregunta={agregarPregunta}
        eliminarPregunta={eliminarPregunta}
        handleSubmit={handleSubmit}
      />
    </Container>
  );
};